import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { useAppStateStore } from '@/features/application'
import router from '@/router'
import { useFactureStore } from './useFactureStore'

export function useFactureRoutingService() {
  const store = useFactureStore()

  async function loadStoreWithKey(key: any): Promise<boolean> {
    try {
      await store.loadData(key)
      return true
    } catch {
      return false
    }
  }

  function navigateToWithKey(key: any) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    router.push(`/${context}/facture/${key}`)
  }

  function navigateToDossierWithKey(key: any) {
    const appState = useAppStateStore()
    const context = TypesContextesAutorisesEnum[appState.contextCourant]
    router.push(`/${context}/dossier/${key}`)
  }

  function navigateToRechercheFacturesList() {
    if (window.history.state.back) {
      router.go(-1)
    } else {
      const appState = useAppStateStore()
      const context = TypesContextesAutorisesEnum[appState.contextCourant]
      router.push(`/${context}/factures`)
    }
  }

  return { loadStoreWithKey, navigateToWithKey, navigateToDossierWithKey, navigateToRechercheFacturesList }
}

